import React, { Component } from 'react';
import { Divider, Button, Form, Loader } from 'semantic-ui-react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as AppActions from '../../actions';

import {
  insertUtmProfile,
  updateUtmProfile
} from '../../services/UtmProfilesService';
import './ManageUTMProfile.css';

class ManageUTMProfile extends Component {
  state = {
    processing: false,
    errorMessage: '',
    successMessage: '',
    utmProfileToEdit: null,
    form: {
      profileName: '',
      canvas: '',
      carousel: '',
      collection: '',
      still: '',
      video: '',
      daa_still: '',
      daa_carousel: ''
    }
  };

  componentDidMount() {
    if (this.props.utmProfileToEdit) {
      this.initializeEdit(this.props.utmProfileToEdit);
    }
  }

  initializeEdit = async (utmProfileToEdit) => {
    const form = { ...this.state.form };
    form.profileName = utmProfileToEdit.name;
    form.canvas = utmProfileToEdit.canvas;
    form.carousel = utmProfileToEdit.carousel;
    form.collection = utmProfileToEdit.collection;
    form.still = utmProfileToEdit.still;
    form.video = utmProfileToEdit.video;
    form.daa_still = utmProfileToEdit.daa_still;
    form.daa_carousel = utmProfileToEdit.daa_carousel;

    this.setState({
      form,
      utmProfileToEdit
    });
  };

  cleanData = () => {
    this.setState({
      form: {
        profileName: '',
        canvas: '',
        carousel: '',
        collection: '',
        still: '',
        video: '',
        daa_still: '',
        daa_carousel: ''
      }
    });
  };

  saveUtmProfile = async () => {
    const {
      profileName,
      canvas,
      carousel,
      collection,
      still,
      video,
      daa_still,
      daa_carousel
    } = this.state.form;
    const { utmProfileToEdit, user } = this.props;

    this.setState({ errorMessage: '', successMessage: '', processing: true });

    const utmProfileData = {
      name: profileName,
      canvas,
      carousel,
      collection,
      still,
      video,
      daa_still,
      daa_carousel,
      user: user.email.trim()
    };

    if (utmProfileToEdit) {
      utmProfileData.id = utmProfileToEdit.id;
    }

    const result = !utmProfileToEdit
      ? await insertUtmProfile(utmProfileData)
      : await updateUtmProfile(utmProfileData);

    if (result.statusCode === 200) {
      const successMessage = !utmProfileToEdit
        ? 'The UTM Profile has been created'
        : 'The UTM Profile Ad has been updated';

      if (!utmProfileToEdit) {
        this.cleanData();
      }

      this.setState({ successMessage, processing: false });
    } else {
      this.setState({
        errorMessage: 'There was an error saving the UTM Profile',
        processing: false
      });
    }
  };

  handleFormChange = (event, { name, value }) => {
    this.setState({ form: { ...this.state.form, [name]: value } });
  };

  render() {
    const { searchPage } = this.props;
    const {
      profileName,
      canvas,
      carousel,
      collection,
      still,
      video,
      daa_still,
      daa_carousel
    } = this.state.form;
    const { processing, errorMessage, successMessage } = this.state;

    return (
      <div>
        {processing ? (
          <div>
            <span>
              <Loader inline className="active" />
              Processing...
            </span>
          </div>
        ) : null}
        <div className="utm-builder-message-container">
          {errorMessage ? (
            <div>
              <span className="utm-builder-error">{errorMessage}</span>
            </div>
          ) : null}
          {successMessage ? (
            <div>
              <span className="utm-builder-message">{successMessage}</span>
            </div>
          ) : null}
        </div>
        <Button onClick={searchPage} size="small" color="grey">
          Back
        </Button>
        <Button onClick={this.saveUtmProfile} size="small" color="blue">
          Save
        </Button>
        <Divider hidden />
        <div>
          <span>
            <b>Profile Name:</b>
          </span>
        </div>
        <Form.Input
          placeholder="Profile Name"
          type="text"
          name="profileName"
          value={profileName}
          onChange={this.handleFormChange}
        />
        <Divider hidden />
        <span>
          <b>Enter UTMs for this campaign below</b>
        </span>
        <Divider hidden />
        <div>
          <span>
            <b>Canvas:</b>
          </span>
        </div>
        <Form.Input
          placeholder="Canvas"
          type="text"
          name="canvas"
          value={canvas}
          onChange={this.handleFormChange}
        />
        <Divider hidden />
        <div>
          <span>
            <b>Carousel:</b>
          </span>
        </div>
        <Form.Input
          placeholder="Carousel"
          type="text"
          name="carousel"
          value={carousel}
          onChange={this.handleFormChange}
        />
        <Divider hidden />
        <div>
          <span>
            <b>Collection:</b>
          </span>
        </div>
        <Form.Input
          placeholder="Collection"
          type="text"
          name="collection"
          value={collection}
          onChange={this.handleFormChange}
        />
        <Divider hidden />
        <div>
          <span>
            <b>Still:</b>
          </span>
        </div>
        <Form.Input
          placeholder="Still"
          type="text"
          name="still"
          value={still}
          onChange={this.handleFormChange}
        />
        <Divider hidden />
        <div>
          <span>
            <b>Video:</b>
          </span>
        </div>
        <Form.Input
          placeholder="Video"
          type="text"
          name="video"
          value={video}
          onChange={this.handleFormChange}
        />
        <Divider hidden />
        <div>
          <span>
            <b>DAA Still:</b>
          </span>
        </div>
        <Form.Input
          placeholder="DAA Still"
          type="text"
          name="daa_still"
          value={daa_still}
          onChange={this.handleFormChange}
        />
        <Divider hidden />
        <div>
          <span>
            <b>DAA Carousel:</b>
          </span>
        </div>
        <Form.Input
          placeholder="DAA Carousel"
          type="text"
          name="daa_carousel"
          value={daa_carousel}
          onChange={this.handleFormChange}
        />
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  user: state.user
});

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(AppActions, dispatch)
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ManageUTMProfile);



// WEBPACK FOOTER //
// ./src/screens/UTMProfiles/ManageUTMProfile.js